import classNames from 'classnames';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import styles from './GeneratedLayoutComponent.less';
import {LayoutComponent} from 'src/js/model/layout_config';

interface OwnProps {
  dataComponent: React.ReactNode;
  dataMap: Record<string, any>;
  dataPropName: string;
  layoutComponent: LayoutComponent;
  data: Record<string, any>;
  reportId: string;
}

type Props = OwnProps;

export const GeneratedLayoutComponent: React.FC<Props> = (props) => {
  const {
    layoutComponent,
    dataComponent,
    dataMap,
    dataPropName,
    data,
    reportId,
    ...restProps
  } = props;

  let componentConfig;
  let componentData;
  let componentProps;
  let DataComponent;

  if (
    layoutComponent.getData() &&
    dataMap &&
    dataMap[layoutComponent.getData().getId()]
  ) {
    DataComponent = dataComponent;
    componentConfig = dataMap[layoutComponent.getData().getId()];
    componentData = data[componentConfig?.getSourceDataKey()];
    componentProps = {
      ...restProps,
      [dataPropName]: componentConfig,
      data: componentData,
      reportId,
    };
  }

  return (
    <div
      className={classNames({
        [styles.dlBorder]: layoutComponent.getConfig().getBorder(),
      })}
      style={layoutComponent.getBoxStyle()}
    >
      <div
        className={classNames({
          [styles.dlGeneratedLayoutComponent]: true,
          [styles.dlFillHeight]: layoutComponent.getConfig().getFillHeight(),
        })}
      >
        {layoutComponent.getConfig().getTitle() ? (
          <div
            className={styles.dlTitle}
            style={layoutComponent.getTitleStyle()}
          >
            <FormattedMessage id={layoutComponent.getConfig().getTitle()} />
          </div>
        ) : null}
        <div
          className={styles.dlContent}
          style={layoutComponent.getContentStyle()}
        >
          {layoutComponent.getChildren() &&
          layoutComponent.getChildren().length > 0
            ? layoutComponent
                .getChildren()
                .map((child) => (
                  <GeneratedLayoutComponent
                    key={child.getId()}
                    layoutComponent={child}
                    dataComponent={dataComponent}
                    dataPropName={dataPropName}
                    dataMap={dataMap}
                    data={data}
                    reportId={reportId}
                    {...restProps}
                  />
                ))
            : null}
          {componentConfig ? <DataComponent {...componentProps} /> : null}
        </div>
      </div>
    </div>
  );
};

GeneratedLayoutComponent.displayName = 'GeneratedLayoutComponent';
